// Dynamic Configs
export const dynamicConfig = "telehealth_config";
export const blockedTelehealthPatientShortIds =
  "blocked_telehealth_patient_short_ids";
export const announcementConfig = "telehealth_announcement";
export const aiManualQaProviders = "ai_qa_opted_in_providers";
export const retryConfigForClientMissingRequiredConsentsQuery =
  "retry_config_for_client_missing_required_consents_query";

// Feature Gates
export const whiteboardEnabledGate = "telehealth_whiteboard_enabled";
export const aiAssistedPrescriberNotesGate = "ai_assisted_prescriber_notes";
export const delayedEntryGate = "telehealth_delayed_entry";
export const disableTranscriptionForMultipleParticipants =
  "telehealth_disable_transcription_for_multiple_participants";
export const toastViewTransitionsGate = "telehealth_toast_view_transitions";
export const whiteboardEventualConsistencyGate =
  "telehealth_whiteboard_eventual_consistency";
export const wordpressUrlMigrationGate = "wordpress_url_migration";
export const blockInvalidUrlsGate = "telehealth_block_invalid_urls";
export const waitingRoomTimeoutGate = "telehealth_waiting_room_timeout";
export const preSessionReflectionsGate = "pre_session_reflections_clientside";
export const clientUserAuthGate = preSessionReflectionsGate;
export const clientInformationSeedlingGate =
  "use_client_information_provider_prep_ia";
export const providerPatientReflectionsUIEnabledGate =
  "provider_patient_reflections_ui_enabled";
export const convertAppointmentDrawerToSeedlingTelehealthGate =
  "convert_appointment_drawer_to_seedling_telehealth";
export const shouldUseSeedlingClientInfoDrawer =
  "should_use_seedling_client_info_drawer";
export const preVisitSummaryEnabledGate = "pre_visit_summary_enabled";
export const enableZoomGate = "telehealth_enable_zoom";
export const v2RecurringAppointmentsGate = "use_v2_recurring_appointments";
export const noMigrationV2RecurringAppointmentsGate =
  "no_migration_v2_recurring_appointments";
export const markAppointmentCompletedMutationGate =
  "mark_appointment_completed_mutation";
export const providerWaitingRoomTranscriptionConsentModalGate =
  "provider_waiting_room_transcription_consent_modal";
export const telehealthManualAdmissionFlowGate =
  "telehealth_manual_admission_flow";
export const telehealthIntroRoomRedesignGate = "telehealth_intro_room_redesign";
export const telehealthRequiredConsentsWaitingRoomBlockGate =
  "telehealth_required_consents_waiting_room_block";
export const showClientCocBannerGate = "show_client_coc_banner";
export const telehealthRejoinRoomGate = "telehealth_rejoin_room";
export const shouldShowPiiAuthFlowGate = "should_show_pii_auth_flow";
export const telehealthLogOutUnauthorizedClientsGate =
  "telehealth_log_out_unauthorized_clients";
export const telehealthVisitorRouteRedirectGate =
  "telehealth_visitor_route_redirect";
